import Img404 from '../assets/images/img_404.png'

const Errer404 = () => {
  return (
    <div className="impression">
      <div className="page404">
         <img src={ Img404 } />
        <h1 className="404">404</h1>
        <h2>Page not Found</h2>
        <p className="impression-sub-text">お探しのページが見つかりませんでした</p>
        <a href="https://suama-catscafe.com/nanineko/" className="a-text-link">動物行動学者監修「うちの子何ねこ？」愛猫診断アプリ</a>
      </div>
    </div>
  )
}
  
  export default Errer404